import React from "react";
import {AppBar, Box, List, ListItem, ListItemText, Toolbar, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import {NavMenuListItem} from "./NavMenuListItem";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed" sx={{"backgroundColor": "#ababab", top: "auto", bottom: 0}}>
        <Toolbar>
          <Typography
            style={{paddingTop: '2px', fontSize: '10px', textAlign: 'center', fontStyle: 'italic'}}>
            {`Copyright © ${year} Predictive Science Inc. All rights reserved.`}
          </Typography>
          <Box flexGrow={1}/>
          <List disablePadding={false}>
            <ListItem button
              component={'a'}
              href={'https://www.predsci.com/portal/home.php'}
              target='_blank'
              rel='noopener noreferrer'
              sx={{
                transition: 'transform 0.2s ease, text-shadow 0.2s ease',
                transformOrigin: 'center',
                '&:hover': {
                  transform: 'scale(1.1)',
                  textShadow: '0px 3px 3px rgba(0, 0, 0, 0.9)',
                },
              }}
            >
              <ListItemText primary={"PREDICTIVE SCIENCE INC."}
                            sx={{ textAlign: 'center' }}
                            primaryTypographyProps={{fontSize: '13px', fontFamily: 'Share'}}
              />
          </ListItem>
            {/*<NavMenuListItem linkTo={'https://www.predsci.com/portal/home.php'} text={"PREDICTIVE SCIENCE INC."} background={'#2A2A2F'}/>*/}
          </List>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export {Footer};